import "./FAQ.css";

function FAQ() {
  return (
    <section id="faq" className="faq-section">
      <div className="faq-content">
        <h2 className="faq-heading">FAQs</h2>
        
        <div className="faq-item">
          <h3 className="faq-question">What is the Indian Army Quiz?</h3>
          <p className="faq-answer">
            The Indian Army Quiz is a national-level school quiz competition presented by the Directorate General of Recruiting. It is designed to build awareness about India, its heritage, and the Indian Army, while encouraging curiosity, teamwork, and critical thinking among students.
          </p>
        </div>

        <div className="faq-item">
          <div className="faq-separator"></div>
          <h3 className="faq-question">What are the topics for the Quiz?</h3>
          <p className="faq-answer">
            Approximately 30% of the questions will be based on the study material shared with participating schools and the Indian Army–related content available on the official website.
            <br /><br />
            The remaining questions will cover a wide range of topics related to India, including: History & Geography, Science & Technology, Current Affairs, Sports, Books & Movies, Heritage & Culture, Travel & Tourism
          </p>
        </div>

        <div className="faq-item">
          <div className="faq-separator"></div>
          <h3 className="faq-question">Who can participate in the quiz?</h3>
          <p className="faq-answer">
            All registered schools in India are eligible.
            <br />
            Students studying in Class 9 to Class 12 can participate.
            <br />
            Each school can nominate one team consisting of two students.
          </p>
        </div>

        <div className="faq-item">
          <div className="faq-separator"></div>
          <h3 className="faq-question">Is this an individual or team-based quiz?</h3>
          <p className="faq-answer">
            This is a team-based quiz.
            <br />
            Each team must consist of two students from the same school.
          </p>
        </div>

        <div className="faq-item">
          <div className="faq-separator"></div>
          <h3 className="faq-question">Is this an online or offline quiz?</h3>
          <p className="faq-answer">
            The quiz follows a hybrid format and will be conducted in multiple stages:
            <br />
            Online rounds (preliminary or qualification rounds) conducted virtually.
            <br />
            Offline / physical rounds (for shortlisted teams) conducted at designated venues.
            <br /><br />
            Details of each stage will be shared with registered schools in advance.
          </p>
        </div>

        <div className="faq-item">
          <div className="faq-separator"></div>
          <h3 className="faq-question">Is there any registration fee?</h3>
          <p className="faq-answer">
            There is no registration fee for the event.
          </p>
        </div>

        <div className="faq-item">
          <div className="faq-separator"></div>
          <h3 className="faq-question">Will participants receive certificates?</h3>
          <p className="faq-answer">
            Yes. All students who successfully complete the first round of the quiz will receive a Participation Certificate.
          </p>
        </div>

        <div className="faq-item">
          <div className="faq-separator"></div>
          <h3 className="faq-question">What prizes are offered in the competition?</h3>
          <p className="faq-answer">
            The competition offers exciting prizes for winners. Prize details will be announced and shared later.
          </p>
        </div>

        <div className="faq-item">
          <div className="faq-separator"></div>
          <h3 className="faq-question">Can a school change team members after registration?</h3>
          <p className="faq-answer">
            No. Once the quiz competition begins, team composition cannot be changed under any circumstances.
          </p>
        </div>

        <div className="faq-item">
          <div className="faq-separator"></div>
          <h3 className="faq-question">How will schools be informed about shortlisted teams and next rounds?</h3>
          <p className="faq-answer">
            All official communication will be shared to the schools & the school coordinators.
          </p>
        </div>

        <div className="faq-item">
          <div className="faq-separator"></div>
          <h3 className="faq-question">What is the format of the preliminary round?</h3>
          <p className="faq-answer">
            The preliminary round will be conducted online and will consist of 20 multiple-choice questions (MCQs) in a fastest-finger–first format.
            <br /><br />
            Participants will be scored based on accuracy, and speed of response — the faster a correct answer is submitted, the higher the score awarded.
            <br /><br />
            Students are strongly advised to answer independently. Seeking help or assistance from others is strictly prohibited.
          </p>
        </div>

        <div className="faq-item">
          <div className="faq-separator"></div>
          <h3 className="faq-question">Who should I reach out to for queries?</h3>
          <p className="faq-answer">
            For any assistance please Whatsapp -{" "}
            <a 
              href="https://wa.me/918940866606" 
              target="_blank" 
              rel="noopener noreferrer"
              className="contact-link whatsapp-link"
            >
              +91-8940866606
            </a>
            {" "}or{" "}
            <a 
              href="https://wa.me/919843970112" 
              target="_blank" 
              rel="noopener noreferrer"
              className="contact-link whatsapp-link"
            >
              +91-9843970112
            </a>
            {" "}(10AM - 5:30PM)
            <br /><br />
            Email -{" "}
            <a 
              href="mailto:info@quizcatalyst.com" 
              className="contact-link email-link"
            >
              info@quizcatalyst.com
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}

export default FAQ;

